import APIRest from './rest'

const USER_API = APIRest

export default USER_API
